// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dev-tier {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    font-family: inherit;
}

.dev-tier__toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    background: rgba(18, 18, 22, 0.94);
    border: 1px solid rgba(192, 159, 83, 0.4);
    border-radius: 20px;
    cursor: pointer;
    font-family: inherit;
    font-size: 0.75rem;
    color: #c8c8c8;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    transition: border-color 0.2s ease;
}

.dev-tier__toggle:hover {
    border-color: rgba(192, 159, 83, 0.7);
}

.dev-tier__badge {
    font-weight: 700;
    font-size: 0.5625rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #c0a053;
    background: rgba(192, 159, 83, 0.13);
    border-radius: 4px;
    padding: 2px 6px;
}

.dev-tier__current {
    font-weight: 500;
    color: #e8e8e8;
}

.dev-tier__current--override {
    color: #c0a053;
}

/* ── Panel ──────────────────────────────────────────────── */
.dev-tier__panel {
    position: absolute;
    bottom: calc(100% + 10px);
    right: 0;
    min-width: 230px;
    background: rgba(18, 18, 22, 0.97);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px;
    padding: 16px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(14px);
}

.dev-tier__heading {
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #606060;
    margin: 0 0 12px;
}

.dev-tier__options {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.dev-tier__option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(255, 255, 255, 0.03);
    color: #c0c0c0;
    font-size: 0.8125rem;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
    text-align: left;
    width: 100%;
}

.dev-tier__option:hover {
    background: rgba(255, 255, 255, 0.07);
    color: #f0f0f0;
    border-color: rgba(255, 255, 255, 0.14);
}

.dev-tier__option--active {
    border-color: rgba(192, 159, 83, 0.5);
    background: rgba(192, 159, 83, 0.1);
    color: #faf6ee;
}

.dev-tier__price {
    font-size: 0.75rem;
    color: #606060;
}

.dev-tier__option--active .dev-tier__price {
    color: #c0a053;
}

.dev-tier__option--reset {
    color: #707070;
    font-size: 0.75rem;
    margin-top: 4px;
    border-color: rgba(255, 255, 255, 0.04);
}

.dev-tier__option--reset:hover {
    color: #c0c0c0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/DevTierSwitcher/Style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kCAAkC;IAClC,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,8DAA8D;AAC9D;IACI,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,kCAAkC;IAClC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,cAAc;IACd,oBAAoB;IACpB,oBAAoB;IACpB,eAAe;IACf,4EAA4E;IAC5E,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".dev-tier {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 9999;\n    font-family: inherit;\n}\n\n.dev-tier__toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 14px;\n    background: rgba(18, 18, 22, 0.94);\n    border: 1px solid rgba(192, 159, 83, 0.4);\n    border-radius: 20px;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: 0.75rem;\n    color: #c8c8c8;\n    backdrop-filter: blur(10px);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n    transition: border-color 0.2s ease;\n}\n\n.dev-tier__toggle:hover {\n    border-color: rgba(192, 159, 83, 0.7);\n}\n\n.dev-tier__badge {\n    font-weight: 700;\n    font-size: 0.5625rem;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: #c0a053;\n    background: rgba(192, 159, 83, 0.13);\n    border-radius: 4px;\n    padding: 2px 6px;\n}\n\n.dev-tier__current {\n    font-weight: 500;\n    color: #e8e8e8;\n}\n\n.dev-tier__current--override {\n    color: #c0a053;\n}\n\n/* ── Panel ──────────────────────────────────────────────── */\n.dev-tier__panel {\n    position: absolute;\n    bottom: calc(100% + 10px);\n    right: 0;\n    min-width: 230px;\n    background: rgba(18, 18, 22, 0.97);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 14px;\n    padding: 16px;\n    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(14px);\n}\n\n.dev-tier__heading {\n    font-size: 0.625rem;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: #606060;\n    margin: 0 0 12px;\n}\n\n.dev-tier__options {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.dev-tier__option {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 14px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(255, 255, 255, 0.03);\n    color: #c0c0c0;\n    font-size: 0.8125rem;\n    font-family: inherit;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n    text-align: left;\n    width: 100%;\n}\n\n.dev-tier__option:hover {\n    background: rgba(255, 255, 255, 0.07);\n    color: #f0f0f0;\n    border-color: rgba(255, 255, 255, 0.14);\n}\n\n.dev-tier__option--active {\n    border-color: rgba(192, 159, 83, 0.5);\n    background: rgba(192, 159, 83, 0.1);\n    color: #faf6ee;\n}\n\n.dev-tier__price {\n    font-size: 0.75rem;\n    color: #606060;\n}\n\n.dev-tier__option--active .dev-tier__price {\n    color: #c0a053;\n}\n\n.dev-tier__option--reset {\n    color: #707070;\n    font-size: 0.75rem;\n    margin-top: 4px;\n    border-color: rgba(255, 255, 255, 0.04);\n}\n\n.dev-tier__option--reset:hover {\n    color: #c0c0c0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
